import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import { mapFacets, mapSelected } from "@/pages/search/searchHooks/utils";
import { api__doSearch_with_params } from "@/apis/search/search";
import { handleFilter } from "@/pages/search/searchHooks/filtersHelpers";
import { SECURE_COOKIE } from "@globalConfig";
import useCookieClient from "@hooks/useCookieClient";
export var getSearch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var _ref$req, req, filters, link, page, sort, size, searchResults;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$req = _ref.req, req = _ref$req === void 0 ? null : _ref$req, filters = _ref.filters, link = _ref.link, page = _ref.page, sort = _ref.sort, size = _ref.size;
          filters = handleFilter(filters);
          _context.next = 4;
          return api__doSearch_with_params({
            req: req,
            page: page,
            sort: sort,
            size: size,
            filters: filters,
            link: link,
            includes: ["usps", "meta_tags"]
          });
        case 4:
          searchResults = _context.sent;
          return _context.abrupt("return", {
            posts: searchResults.products,
            usps: searchResults.usps,
            filters: mapFacets(searchResults.facets) || [],
            marketingBanner: {
              desktop: searchResults.marketing_banner_desktop,
              mobile: searchResults.marketing_banner_mobile
            },
            similarItems: searchResults.similar_items,
            dealFacet: searchResults.deal,
            specs: searchResults.specs,
            selectedOptions: mapSelected(searchResults.selected),
            //
            metaData: {
              seoData: searchResults.seo_data,
              totalPages: searchResults.total_pages,
              title: searchResults.title,
              currentPage: Math.min(searchResults.total_pages, searchResults.page),
              productsCount: searchResults.products_count,
              category_path: searchResults.category_path,
              request_id: searchResults.request_id,
              metaTags: searchResults.meta_tags
            },
            search_meta: searchResults.search_meta
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSearch(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var unbxdAnalytics = function unbxdAnalytics(data) {
  //!!warning!! this was needed for unbxd but not for TypeSense
  //if (data.action !== "visitor" && !data.requestId) return;
  var _getOrCreateUnbxdUser = getOrCreateUnbxdUserId(),
    uid = _getOrCreateUnbxdUser.uid,
    isNew = _getOrCreateUnbxdUser.isNew;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient,
    setCookieClient = _useCookieClient.setCookieClient;
  data.uid = uid;
  data.visit_type = isNew ? "first_time" : "repeat";
  var visitId = getCookieClient("visitId");
  if (!visitId) {
    visitId = "visitId-".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 100000));

    // Create a date object for the current time
    var currentDate = new Date();

    // Set the cookie to expire 30 minutes from now
    var expireTime = new Date(currentDate.getTime() + 30 * 60000); // 60000 milliseconds in a minute

    // Save the cookie with the expiration time
    setCookieClient("visitId", visitId, {
      path: "/",
      expires: expireTime,
      sameSite: true,
      secure: SECURE_COOKIE
    });
  }
  fetcher(null, true).post("/search/track", _objectSpread(_objectSpread({}, data), {}, {
    visitId: visitId,
    referrer: getReferralURL()
  }))["catch"](function (e) {
    return Promise.resolve("Ignore search analytics error");
  });
};
export function getReferralURL() {
  // Check if running in a browser environment
  if (typeof window !== "undefined" && window.dataLayer) {
    // Filter the dataLayer array for 'gtm.historyChange' events

    var filtered = window.dataLayer.filter(function (s) {
      return s.event === "gtm.historyChange";
    });
    if (filtered.length > 0) {
      var _filtered$gtmOldUrl, _filtered;
      // Access the last element's 'gtm.oldUrl' property and decode it
      var lastUrl = decodeURI((_filtered$gtmOldUrl = (_filtered = filtered[filtered.length - 1]) === null || _filtered === void 0 ? void 0 : _filtered["gtm.oldUrl"]) !== null && _filtered$gtmOldUrl !== void 0 ? _filtered$gtmOldUrl : "");
      return lastUrl;
    }
  }

  // Fall back to document.referrer if available
  if (typeof document !== "undefined" && document.referrer) {
    return document.referrer;
  }

  // Return empty string if no referrer is found
  return "";
}
export var getOrCreateUnbxdUserId = function getOrCreateUnbxdUserId() {
  var _useCookieClient2 = useCookieClient(),
    getCookieClient = _useCookieClient2.getCookieClient,
    setCookieClient = _useCookieClient2.setCookieClient;
  var UUID = getCookieClient("UUID");
  var isUnbxdNewUser = false;
  if (!UUID) {
    UUID = "uid-".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 100000));
    isUnbxdNewUser = true;
    setCookieClient("UUID", UUID, {
      path: "/",
      maxAge: 3600 * 24 * 365 * 10,
      sameSite: true,
      secure: SECURE_COOKIE
    });
  }
  return {
    uid: UUID,
    isNew: isUnbxdNewUser
  };
};